export enum OfficeCategory {
  GROUP = "GROUP",
  OFFICE = "OFFICE",
}
